// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"e1565113","857":"f271aa4e","883":"d73ece7f"}[chunkId] + ".js";
};